<template>
  <div class="mb-5">
    <v-card flat outlined :loading="isMainLoading || isLoading || isSearching" min-height="30">
      <v-card-title class="date-selector-box">
        <div>{{ $t('market.select_date_to_analyze') }}</div>
        <v-menu
          v-model="menuStartDate"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="$helper.datelabel(startDate)"
              :placeholder="$t('date')"
              outlined
              dense
              hide-details
              readonly
              v-bind="attrs"
              v-on="on"
              :label="$t('from_date')"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="startDate"
            no-title
            locale="th"
            @input="menuStartDate = false"
            :header-date-format="$helper.headerDateFormat"
            :year-format="$helper.yearFormat"
            :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"
          ></v-date-picker>
        </v-menu>
        <v-menu
          v-model="menuEndDate"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="$helper.datelabel(endDate)"
              :placeholder="$t('date')"
              outlined
              dense
              hide-details
              readonly
              v-bind="attrs"
              v-on="on"
              :label="$t('to_date')"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="endDate"
            no-title
            locale="th"
            @input="menuEndDate = false"
            :header-date-format="$helper.headerDateFormat"
            :year-format="$helper.yearFormat"
            :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"
          ></v-date-picker>
        </v-menu>
        <v-btn @click="onSearch()" class="primary" :disabled="isLoading">
          <v-icon>mdi-magnify</v-icon>{{ $t('search') }}
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="sh-db">
          <div class="dashboard">
            <div class="dashboard-header">
              <div class="head">{{ $t('income.summary_income') }}</div>
              <!-- <div>ในเดือนปัจจุบัน</div> -->
              <div class="tail">
                <div>{{ $t('invoice.invoice_data') }}</div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  <div>{{ $t('invoice.invoice_data_by_document_date_in_month') }}</div>
                </v-tooltip>
              </div>
            </div>
            <div class="dashboard-box">
              <div>{{ $t('income.accumulated_income') }}</div>
              <template v-if="!isLoading && dataIncomePrepare">
                <div class="h-number">
                  {{dataIncomePrepare.totalValue || 0 | currency}}
                  <span>{{ $helper.currencySign() }}</span>
                </div>
              </template>
              <v-progress-circular v-if="isLoading" indeterminate color="primary" size="25"></v-progress-circular>
            </div>
            <div class="dashboard-box">
              <div>{{ $t('income.income_in_month') }} {{dataIncomePrepare ? dataIncomePrepare.lastMonth : '-'}}</div>
              <template v-if="!isLoading && dataIncomePrepare">
                <div class="h-number">
                  {{dataIncomePrepare.lastMonthTotalValue || 0 | currency}}
                  <span>{{ $helper.currencySign() }}</span>
                </div>
              </template>
              <v-progress-circular v-if="isLoading" indeterminate color="primary" size="25"></v-progress-circular>
            </div>
            <div class="dashboard-box">
              <div
                v-if="searchStartDate && searchEndDate"
              >{{ $t('income.income_in_date') }} {{$helper.datelabel(searchStartDate)}} - {{$helper.datelabel(searchEndDate)}}</div>
              <template v-if="!isSearching && incomeData">
                <div class="h-number">
                  {{incomeData.total || 0 | currency}}
                  <span>{{ $helper.currencySign() }}</span>
                </div>
              </template>
              <v-progress-circular v-if="isSearching" indeterminate color="primary" size="25"></v-progress-circular>
            </div>
          </div>
        </div>

        <div class="gh px-8">
          <div class="income-date">
            <div>
              <div class="text-center" v-if="searchStartDate && searchEndDate">
                <v-icon class="mr-1">mdi-chart-pie</v-icon>
                {{ $t('income.title') }} {{$helper.datelabel(searchStartDate)}} - {{$helper.datelabel(searchEndDate)}} {{ $t('payment.income_by_payment_method') }}
              </div>
              <div class="all-income-box">
                <div class="pie-chart-box">
                  <canvas
                    :id="`pie-chart-all-income-by-payment-method-${tabType}`"
                    v-show="incomeData && incomeData.total"
                  ></canvas>
                  <div
                    v-show="incomeData && incomeData.total == 0"
                    class="no-data"
                  >{{ $t('market.no_income_in_this_month') }}</div>
                </div>
                <div v-if="incomeData" class="payment-method-box">
                  <div class="mt-5 flex justify-space-between font-bold">
                    <div>
                      <v-icon color="success" class="mr-1">mdi-check-circle</v-icon>{{ $t('payment.paid_income_total') }}
                    </div>
                    <div class="pl-10">{{incomeData.paid.total | currencySuffixTextThEn}}</div>
                  </div>
                  <div
                    class="pl-5 flex justify-space-between"
                    v-for="(incomeByMethod,index) in incomeData.paid.paymentMethod"
                    :key="index"
                  >
                    <div>
                      <v-icon :color="paymentMethodcolors[index]" class="mr-1">mdi-checkbox-blank</v-icon>
                      {{index}}
                    </div>
                    <div>{{incomeByMethod | currencySuffixTextThEn}}</div>
                  </div>
                  <div class="mt-5 flex justify-space-between font-bold">
                    <div>
                      <v-icon color="error" class="mr-1">mdi-close-circle</v-icon>{{ $t('payment.pending_income_total') }}
                    </div>
                    <div>{{incomeData.unPaid.total | currencySuffixTextThEn}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="b">
              <div class="text-center" v-if="searchStartDate && searchEndDate">
                <v-icon class="mr-1">mdi-chart-pie</v-icon>
                {{ $t('income.title') }} {{$helper.datelabel(searchStartDate)}} - {{$helper.datelabel(searchEndDate)}} {{ $t('bill.bill_by_type') }}
              </div>
              <div class="all-income-box">
                <div class="pie-chart-box">
                  <canvas
                    :id="`pie-chart-all-income-by-document-type-${tabType}`"
                    v-show="incomeData && incomeData.total"
                  ></canvas>
                  <div
                    v-show="incomeData && incomeData.total == 0"
                    class="no-data"
                  >{{ $t('market.no_income_in_this_month') }}</div>
                </div>
                <div
                  v-if="incomeData"
                  class="payment-method-box"
                >
                  <div
                    class="flex justify-space-between"
                    v-for="(documentType,index) in incomeData.documentType"
                    :key="index"
                  >
                    <div class="mr-5">
                      <v-icon :color="documentTypeColors[index]" class="mr-1">mdi-checkbox-blank</v-icon>
                      {{index}}
                    </div>
                    <div>{{documentType | currencySuffixTextThEn}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center ali mt-10">
          <v-icon class="mr-1">mdi-chart-bar</v-icon>{{ $t('income.income_and_growth_rate_chart') }}
        </div>
        <div class="yearly-income-box">
          <div class="bar-chart-box">
            <canvas :id="`bar-chart-overview-income-split-${tabType}`"></canvas>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SelectMonthYear from "@/components/SelectMonthYear.component";
import { Chart } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Invoice, Receipt } from "../classes";
Chart.register(ChartDataLabels);
let pieChartIncomeByPaymentMethod,
  pieChartIncomeByDocumentType,
  barChartIncomeYearly,
  barChartOverviewIncomeSplit;
export default {
  props: {
    isMainLoading: Boolean,
    tabType: {
      type: String,
      default: "THB"
    }
  },
  components: { SelectMonthYear },
  computed: {
    ...mapGetters({
      receipts: "receipt/getReceipts",
      // invoices: "invoice/getInvoiceOverall",
      incomeOverall: "invoice/getInvoiceOverall"
    })
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      isLoading: false,
      isSearching: false,
      menuStartDate: false,
      menuEndDate: false,
      startDate: this.$moment({ day: 1 }).format("YYYY-MM-DD"),
      endDate: this.$moment()
        .endOf("month")
        .format("YYYY-MM-DD"),
      selectedMonthYear: null,
      incomeData: null,
      incomeDataYear: null,
      pieChartMonthlyIncome: {
        type: "pie",
        data: {
          labels: [],
          datasets: []
        },
        options: {
          layout: {
            padding: {
              top: 20,
              left: 40,
              right: 40
            }
          },
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              enabled: true,
              callbacks: {
                footer: ttItem => {
                  let sum = 0;
                  let dataArr = ttItem[0].dataset.data;
                  dataArr.map(data => {
                    sum += Number(data);
                  });
                  let percentage =
                    ((ttItem[0].parsed * 100) / sum).toFixed(2) + "%";
                  return `${this.$t('income.income_ratio')} ${percentage}`;
                }
              }
            },
            datalabels: {
              align: "top",
              anchor: "end",
              font: {
                size: 15,
                weight: "bold"
              },
              color: "#FFFFFF",
              textAlign: "center",
              textStrokeColor: "#00000050",
              textStrokeWidth: 3,
              formatter: (val, context) => {
                let text;
                text = `${this.$helper.toCurrency(parseFloat(val || 0), null, { isAbbreviate: true, isPrefixSign: true })}`;
                return text;
              }
            }
          },
          responsive: true
        }
      },
      pieChartIncomeByDocumentType: {
        type: "pie",
        data: {
          labels: [],
          datasets: []
        },
        options: {
          layout: {
            padding: {
              top: 20,
              left: 40,
              right: 40
            }
          },
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              enabled: true,
              callbacks: {
                footer: ttItem => {
                  let sum = 0;
                  let dataArr = ttItem[0].dataset.data;
                  dataArr.map(data => {
                    sum += Number(data);
                  });
                  let percentage =
                    ((ttItem[0].parsed * 100) / sum).toFixed(2) + "%";
                  return `${this.$t('income.income_ratio')} ${percentage}`;
                }
              }
            },
            datalabels: {
              align: "top",
              anchor: "end",
              font: {
                size: 15,
                weight: "bold"
              },
              color: "#FFFFFF",
              textAlign: "center",
              textStrokeColor: "#00000075",
              textStrokeWidth: 3,
              formatter: (val, context) => {
                let text;
                text = `${this.$helper.toCurrency(parseFloat(val || 0), null, { isAbbreviate: true, isPrefixSign: true })}`;
                return text;
              }
            }
          },
          responsive: true
        }
      },
      paymentMethodcolors: {
        [this.$t('payment.pending')]: "#F25C5D",
        [this.$t('payment.methods.1')]: "#5fff5f",
        [this.$t('payment.methods.2')]: "#5fffd7",
        [this.$t('payment.methods.3')]: "#baff5f",
        [this.$t('payment.methods.4')]: "#5fffb4",
        [this.$t('payment.methods.5')]: "#5fa4ff",
        [this.$t('payment.methods.6')]: "#c7ff5f",
        [this.$t('payment.methods.7')]: "#0f3e68",
        [this.$t('payment.methods.8')]: "#663399"
      },
      documentTypeColors: {
        [this.$t('bill.document_type.1')]: "#F25C5D",
        [this.$t('bill.document_type.2')]: "#5fff5f",
        [this.$t('bill.document_type.3')]: "#5fffd7",
        [this.$t('bill.document_type.4')]: "#baff5f",
        [this.$t('bill.document_type.5')]: "#5fffb4",
        [this.$t('bill.document_type.6')]: "#5fa4ff",
        [this.$t('bill.document_type.7')]: "#c7ff5f",
        [this.$t('bill.document_type.8')]: "#c7ff5f"
      },
      dataIncomes: null,
      dataIncomePrepare: null,
      isMountedCheckPieChartIncomeByPaymentMethod: false,
      isMountedCheckPieChartIncomeByDocumentType: false,
      isMountedCheckBarChartIncomeYearly: false,
      isMountedCheckBarChartOverviewIncome: false,

      dataBetweenDateInvoices: [],
      dataYearlyBetweenDateInvoices: [],
      searchStartDate: null,
      searchEndDate: null
    };
  },
  mounted() {
    this.isMountedCheckPieChartIncomeByPaymentMethod = true;
    this.isMountedCheckPieChartIncomeByDocumentType = true;
    this.isMountedCheckBarChartIncomeYearly = true;
    this.isMountedCheckBarChartOverviewIncome = true;
    this.initData();
  },
  methods: {
    async initData() {
      this.isLoading = true;
      try {
        this.dataIncomes = await this.getOverAllInvoices();
        this.dataIncomePrepare = await this.prepareDataOverviewIncome(
          this.dataIncomes.sort(
            (a, b) =>
              this.$moment(a.objectId, "MM/YYYY") -
              this.$moment(b.objectId, "MM/YYYY")
          )
        );
        this.initBarChartMonthlyIncome(this.dataIncomePrepare);

        this.onSearch();

        this.isLoading = false;
      } catch (error) {
        console.log(error);
        if (error?.response?.data?.error) {
          this.errorMsg = error.response.data.error;
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        this.isLoading = false;
      }
    },
    async onSearch() {
      this.isSearching = true;
      try {
        await this.getInvoicesBetweenDateByMarket();
        this.incomeData = await this.prepareDataInvoices();
        this.initPieChartMonthlyIncome(this.incomeData);
        this.initPieChartIncomeByDocumentType(this.incomeData);
        this.isSearching = false;
      } catch (error) {
        console.log(error);
        if (error?.response?.data?.error) {
          this.errorMsg = error.response.data.error;
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        this.isSearching = false;
      }
    },
    async getInvoicesBetweenDateByMarket() {
      try {
        if (
          this.searchStartDate != this.startDate ||
          this.searchEndDate != this.endDate
        ) {
          this.searchStartDate = this.startDate;
          this.searchEndDate = this.endDate;
          let params = {
            isOverall: true,
            marketId: this.marketId,
            isToMainCurrency: true,
            startDate: this.$moment(this.startDate)
              .startOf("day")
              .toISOString(),
            endDate: this.$moment(this.endDate)
              .endOf("day")
              .toISOString()
          }
          let invoices = await this.$helper.queryMore(
            Invoice.getInvoicesBetweenDateByMarket,
            params
          );
          this.dataBetweenDateInvoices = invoices.filter(d => !d.isBadDebt)
        }
      } catch (error) {
        throw error;
      }
    },
    getOverAllInvoices() {
      return this.$store.dispatch("invoice/getOverAllInvoices", {
        projectId: this.projectId,
        marketId: this.marketId
      });
    },
    prepareDataInvoices(invoices = this.dataBetweenDateInvoices) {
      let dataRes = {
        paid: {
          paymentMethod: {},
          documentType: {},
          data: [],
          total: 0
        },
        unPaid: {
          data: [],
          total: 0
        },
        documentType: {},
        total: 0,
        countInvoices: 0,
        countReceipts: 0
      };
      if (invoices && invoices.length) {
        for (const invoice of invoices) {
          if (invoice.isSent) {
            //Income by paymentMethods
            dataRes.total += invoice.totalValue;
            dataRes.unPaid.total += invoice.totalUnpaidValue;
            //Income by documentType
            if (!dataRes.documentType[invoice.documentTypeString])
              dataRes.documentType[invoice.documentTypeString] = 0;
            dataRes.documentType[invoice.documentTypeString] += invoice.totalValue;

            if (invoice.receipts && invoice.receipts.length) {
              for (let _receipt of invoice.receipts) {
                let receipt = new Receipt(_receipt, true, true)
                if (!dataRes.paid.paymentMethod[receipt.paymentMethodText]) dataRes.paid.paymentMethod[receipt.paymentMethodText] = 0;
                if (!dataRes.paid.documentType[invoice.documentTypeString]) dataRes.paid.documentType[invoice.documentTypeString] = 0;
                if (receipt.isPaid) {
                  dataRes.paid.total += receipt.totalValue
                  dataRes.paid.paymentMethod[receipt.paymentMethodText] += receipt.totalValue;
                  dataRes.paid.documentType[invoice.documentTypeString] += receipt.totalValue;
                }
              }
            }
          }
        }
      }
      if (dataRes.paid && dataRes.paid.paymentMethod)
        dataRes.paid.paymentMethod = Object.entries(dataRes.paid.paymentMethod)
          .sort(([, a], [, b]) => b - a)
          .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
      if (dataRes.documentType)
        dataRes.documentType = Object.entries(dataRes.documentType)
          .sort(([, a], [, b]) => b - a)
          .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
      return dataRes;
    },
    prepareDataOverviewIncome(dataIncomes) {
      let dataRes = {
        monthYear: [],
        count: 0,
        totalDiscountNonVatValue: 0,
        totalDiscountValue: 0,
        totalDiscountVatValue: 0,
        totalNonVatItemsValue: 0,
        totalNonVatValue: 0,
        totalPaidValue: 0,
        totalValue: 0,
        totalVatItemsValue: 0,
        totalVatValue: 0,
        totalWhtValue: 0,
        avgTotalValue: 0,
        lastMonth: "",
        lastMonthTotalValue: 0,
        lastMonthTotalDiscountValue: 0,
        lastMonthCount: 0,
        maxTotalValue: Math.max(...dataIncomes.map(o => o.maxTotalValue)),
        minTotalValue: Math.min(...dataIncomes.map(o => o.minTotalValue))
      };
      if (dataIncomes && dataIncomes.length) {
        let dataIncomeObjects = {};
        for (const dataIncome of dataIncomes) {
          dataIncomeObjects[dataIncome.objectId] = dataIncome;
        }
        let minimumMonths = 24;
        let monthYearStop = this.$moment(
          dataIncomes[dataIncomes.length - 1].objectId,
          "MM/YYYY"
        );
        let monthYearStart = this.$moment(dataIncomes[0].objectId, "MM/YYYY");
        let monthYearNumber = monthYearStop.diff(monthYearStart, "months");
        for (
          let numberOfMonth = 0;
          numberOfMonth <=
          (monthYearNumber < minimumMonths ? minimumMonths : monthYearNumber);
          numberOfMonth++
        ) {
          let monthYear = this.$moment(monthYearStop)
            .add(
              monthYearNumber < minimumMonths
                ? -minimumMonths
                : -monthYearNumber,
              "months"
            )
            .add(numberOfMonth, "months")
            .format("MM/YYYY");
          let bfMonthYear = this.$moment(monthYearStop)
            .add(
              monthYearNumber < minimumMonths
                ? -minimumMonths
                : -monthYearNumber,
              "months"
            )
            .add(numberOfMonth - 1, "months")
            .format("MM/YYYY");
          let aYearAgoMonthYear = this.$moment(monthYearStop)
            .add(
              monthYearNumber < minimumMonths
                ? -minimumMonths
                : -monthYearNumber,
              "months"
            )
            .add(numberOfMonth - 12, "months")
            .format("MM/YYYY");
          let dataIncome = dataIncomeObjects[monthYear];
          let bfDataIncome = dataIncomeObjects[bfMonthYear];
          let aYearAgoDataIncome = dataIncomeObjects[aYearAgoMonthYear];
          if (dataIncome) {
            dataIncome.revenueGrowth = bfDataIncome
              ? (dataIncome.totalValue - bfDataIncome.totalValue) /
                bfDataIncome.totalValue
              : 0;
            dataIncome.differenceIncomePrevious = bfDataIncome
              ? dataIncome.totalValue - bfDataIncome.totalValue
              : dataIncome.totalValue;
            dataIncome.differenceYearIncome = aYearAgoDataIncome
              ? dataIncome.totalValue - aYearAgoDataIncome.totalValue
              : dataIncome.totalValue;
            dataIncome.bfYearIncome = aYearAgoDataIncome
              ? aYearAgoDataIncome.totalValue
              : 0;
            dataIncome.aYearAgoMonthYear = aYearAgoMonthYear;
            dataRes.monthYear.push(dataIncome);
            dataRes.count += dataIncome.count;
            dataRes.totalDiscountNonVatValue +=
              dataIncome.totalDiscountNonVatValue;
            dataRes.totalDiscountValue += dataIncome.totalDiscountValue;
            dataRes.totalDiscountVatValue += dataIncome.totalDiscountVatValue;
            dataRes.totalNonVatItemsValue += dataIncome.totalNonVatItemsValue;
            dataRes.totalNonVatValue += dataIncome.totalNonVatValue;
            dataRes.totalPaidValue += dataIncome.totalPaidValue;
            dataRes.totalValue += dataIncome.totalValue;
            dataRes.totalVatItemsValue += dataIncome.totalVatItemsValue;
            dataRes.totalVatValue += dataIncome.totalVatValue;
            dataRes.totalWhtValue += dataIncome.totalWhtValue;
            dataRes.avgTotalValue += dataIncome.avgTotalValue;
            if (monthYear == monthYearStop.format("MM/YYYY")) {
              dataRes.lastMonth = this.$moment(
                dataIncome.objectId,
                "MM/YYYY"
              ).format("MMMM YYYY");
              dataRes.lastMonthTotalValue = dataIncome.totalValue;
              dataRes.lastMonthCount = dataIncome.count;
              dataRes.lastMonthTotalDiscountValue =
                dataIncome.totalDiscountValue;
            }
          } else {
            dataRes.monthYear.push({
              avgTotalValue: 0,
              count: 0,
              differenceIncomePrevious: bfDataIncome
                ? 0 - bfDataIncome.totalValue
                : 0,
              differenceYearIncome: aYearAgoDataIncome
                ? 0 - aYearAgoDataIncome.totalValue
                : 0,
              bfYearIncome: aYearAgoDataIncome
                ? aYearAgoDataIncome.totalValue
                : 0,
              maxTotalValue: 0,
              minTotalValue: 0,
              objectId: monthYear,
              revenueGrowth: bfDataIncome
                ? (0 - bfDataIncome.totalValue) / bfDataIncome.totalValue
                : 0,
              totalDiscountNonVatValue: 0,
              totalDiscountValue: 0,
              totalDiscountVatValue: 0,
              totalNonVatItemsValue: 0,
              totalNonVatValue: 0,
              totalPaidValue: 0,
              totalValue: 0,
              totalVatItemsValue: 0,
              totalVatValue: 0,
              totalWhtValue: 0
            });
          }
        }
        dataRes.avgTotalValue = dataRes.avgTotalValue / dataIncomes.length;
      }
      return dataRes;
    },
    initPieChartMonthlyIncome(dataRes) {
      this.pieChartMonthlyIncome.data.labels = [];
      this.pieChartMonthlyIncome.data.datasets[0] = {
        label: "All Income by payment method",
        data: [],
        backgroundColor: []
      };

      this.pieChartMonthlyIncome.data.labels.push(this.$t('payment.pending'));
      this.pieChartMonthlyIncome.data.datasets[0].data.push(
        dataRes.unPaid.total
      );
      this.pieChartMonthlyIncome.data.datasets[0].backgroundColor.push(
        this.paymentMethodcolors[this.$t('payment.pending')]
      );
      for (const paymentMethod in dataRes.paid.paymentMethod) {
        this.pieChartMonthlyIncome.data.labels.push(paymentMethod);
        this.pieChartMonthlyIncome.data.datasets[0].data.push(
          dataRes.paid.paymentMethod[paymentMethod]
        );
        this.pieChartMonthlyIncome.data.datasets[0].backgroundColor.push(
          this.paymentMethodcolors[paymentMethod]
        );
      }
      if (
        !pieChartIncomeByPaymentMethod ||
        this.isMountedCheckPieChartIncomeByPaymentMethod
      ) {
        let ctx = document.getElementById(
          `pie-chart-all-income-by-payment-method-${this.tabType}`
        );
        if (ctx)
          pieChartIncomeByPaymentMethod = new Chart(
            ctx,
            this.pieChartMonthlyIncome
          );
        this.isMountedCheckPieChartIncomeByPaymentMethod = false;
      } else {
        pieChartIncomeByPaymentMethod.update();
      }
    },
    initPieChartIncomeByDocumentType(dataRes) {
      this.pieChartIncomeByDocumentType.data.labels = [];
      this.pieChartIncomeByDocumentType.data.datasets[0] = {
        label: "Income by document type",
        data: [],
        backgroundColor: []
      };

      for (const documentType in dataRes.documentType) {
        this.pieChartIncomeByDocumentType.data.labels.push(documentType);
        this.pieChartIncomeByDocumentType.data.datasets[0].data.push(
          dataRes.documentType[documentType]
        );
        this.pieChartIncomeByDocumentType.data.datasets[0].backgroundColor.push(
          this.documentTypeColors[documentType]
        );
      }
      if (
        !pieChartIncomeByDocumentType ||
        this.isMountedCheckPieChartIncomeByDocumentType
      ) {
        let ctx = document.getElementById(
          `pie-chart-all-income-by-document-type-${this.tabType}`
        );
        if (ctx)
          pieChartIncomeByDocumentType = new Chart(
            ctx,
            this.pieChartIncomeByDocumentType
          );

        this.isMountedCheckPieChartIncomeByDocumentType = false;
      } else {
        pieChartIncomeByDocumentType.update();
      }
    },
    initBarChartMonthlyIncome(dataIncomePrepare) {
      let _this = this;
      let dataChart = {
        type: "bar",
        data: {
          labels: [],
          datasets: []
        },
        options: {
          responsive: true,
          layout: {
            padding: {
              // top:50
            }
          },
          scales: {
            y: {
              ticks: {
                callback: function(value, index, ticks) {
                  return (
                    `${_this.$helper.currencySign()}` +
                    parseFloat(value)
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  );
                }
              }
            },
            y1: {
              display: false,
              type: "linear",
              position: "right",
              beginAtZero: true
            }
          },
          plugins: {
            labels: {
              render: "value"
            },
            title: {
              text: this.$t('income.income_and_growth_rate_chart'),
              display: false
            },
            tooltip: {
              enabled: true,
              callbacks: {
                label: function(context) {
                  let text;
                  if (context.datasetIndex == 0) {
                    text = `${context.dataset.label} : ${_this.$helper.currencySign()}${parseFloat(
                      context.raw || 0
                    )
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
                  } else if (context.datasetIndex == 1) {
                    text = `${context.dataset.label} : ${(
                      parseFloat(context.raw) * 100
                    )
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}%`;
                  }
                  return text;
                },
                footer: context => {
                  let text;
                  let dataIncome = this.dataIncomePrepare.monthYear.find(
                    d => d.objectId == context[0].label
                  );
                  if (dataIncome)
                    text = `${this.$t('market.rental_income_difference_from_previous_month')}: ${
                      _this.$helper.toCurrency(parseFloat(dataIncome.differenceIncomePrevious || 0), null, { isShowPlus: true, isPrefixSign: true, isNoSpace: true, mathType: "outSide" })
                    }`;
                  return text;
                }
              }
            },
            datalabels: {
              align: "top",
              anchor: "end",
              font: {
                size: 15,
                weight: "bold"
              },
              textAlign: "center",
              textStrokeColor: "#FFFFFF50",
              textStrokeWidth: 1,
              // textShadowColor:'#FFFFFF',

              color: function(context) {
                let color = "#00000099";
                if (context.datasetIndex == 0) {
                  color = `#00000099`;
                } else if (context.datasetIndex == 1) {
                  color =
                    context.dataset.data[context.dataIndex] >= 0
                      ? `#17dd95D0`
                      : `#F25C5DD0`;
                }
                return color;
              },
              formatter: (val, context) => {
                let text;
                let dataIncome = this.dataIncomePrepare.monthYear.find(
                  d =>
                    d.objectId == context.chart.data.labels[context.dataIndex]
                );
                if (context.datasetIndex == 0) {
                  text = `${
                    _this.$helper.toCurrency(parseFloat(val || 0), null, { isAbbreviate: true, isPrefixSign: true, isShowPlus: true, mathType: "outSide" })
                  }`;
                } else if (context.datasetIndex == 1) {
                  text = `${
                    _this.$helper.toCurrency((parseFloat(val) * 100), null, { isShowPlus: true, isPrefixSign: true, mathType: "outSide" })
                    }%${dataIncome
                      ? "\n" + _this.$helper.toCurrency(parseFloat(dataIncome.differenceIncomePrevious || 0), null, { isAbbreviate: true, isPrefixSign: true, isShowPlus: true, mathType: "outSide" })
                      : ""
                  }`;
                }
                return text;
              }
            }
          }
        },
        plugins: [
          ChartDataLabels,
          {
            id: "legendMargin",
            beforeInit: function(chart, options) {
              const fitValue = chart.legend.fit;
              chart.legend.fit = function fit() {
                fitValue.bind(chart.legend)();
                return (this.height += 40);
              };
            }
          }
        ]
      };
      dataChart.data.labels = [];
      dataChart.data.datasets[0] = {
        label: this.$t('income.summary_income'),
        type: "bar",
        data: [],
        backgroundColor: ["#5fffd740"],
        borderColor: ["#5fffd7"],
        borderWidth: 1,
        order: 1
      };
      dataChart.data.datasets[1] = {
        label: this.$t('income.growth_rate_of_income'),
        type: "line",
        data: [],
        backgroundColor: "rgb(255, 239, 149)",
        borderColor: "rgba(255, 221, 30, 0.5)",
        tension: 0.3,
        fill: false,
        yAxisID: "y1",
        order: 0
      };

      for (const index in dataIncomePrepare.monthYear) {
        if (dataIncomePrepare.monthYear.length - index <= 12) {
          let dataIncome = dataIncomePrepare.monthYear[index];
          dataChart.data.labels.push(dataIncome.objectId);
          dataChart.data.datasets[0].data.push(dataIncome.totalValue);
          dataChart.data.datasets[1].data.push(dataIncome.revenueGrowth);
        }
      }
      if (
        !barChartOverviewIncomeSplit ||
        this.isMountedCheckBarChartOverviewIncome
      ) {
        var ctx = document.getElementById(`bar-chart-overview-income-split-${this.tabType}`);
        if (ctx) barChartOverviewIncomeSplit = new Chart(ctx, dataChart);
        this.isMountedCheckBarChartOverviewIncome = false;
      } else {
        barChartOverviewIncomeSplit.update();
      }
    },
    toMonthYearText(data, sub = 0) {
      let text = "";
      if (data) {
        let month = data.month,
          year = data.year;
        text = this.$moment(`${month}/${year}`, "M/YYYY")
          .add(sub * -1, "months")
          .format("MMMM/YYYY");
      }
      return text;
    }
  }
};
</script>

<style lang="scss" scoped>
.date-selector-box {
  display: flex;
  // max-width: 50vw;
  // min-width: 200px;
  justify-content: center;
  align-content: center;
}
.date-selector-box ::v-deep .v-input,
.date-selector-box ::v-deep .v-btn {
  margin-left: 20px;
}
.date-selector-box ::v-deep .v-input {
  // width: 100px;
  max-width: 180px;
  min-width: 100px;
  input {
    text-align: center;
  }
}

.income-date {
  display: flex;
  justify-content: center;
  width: max-content;
  flex-wrap: wrap;
  // flex-flow: row wrap;
  padding: 20px 15px;
  // gap: 15px;
  background: rgba(230, 230, 230, 0.35);
  border-radius: 15px;
  @media only screen and (min-width: 1280px) {
    .b {
      padding-left:10px;
      border-left: 1px solid rgba(167, 167, 167, 0.507);
    }
  }

  .all-income-box {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    max-width: max-content;
    margin: 0 auto;
    .pie-chart-box {
      width: 300px;
      height: 300px;
      margin: 20px 20px 30px;
      .no-data {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        height: 100%;
      }
    }
    .payment-method-box {
      margin: 20px 20px 30px;
      div {
        margin-bottom: 7px;
      }
    }
  }
}
.yearly-income-box {
  margin: 20px 0;
  display: flex;
  justify-content: center;
  .bar-chart-box {
    width: 60vw;
    height: auto;
  }
}
.sh-db {
  display: flex;
  justify-content: center;
  // flex-flow: row wrap;
  margin: 15px 0 25px;
  gap: 15px;
  .dashboard {
    display: flex;
    background: rgba(230, 230, 230, 0.35);
    border-radius: 15px;
    max-width: max-content;
    flex-wrap: wrap;
    .dashboard-header {
      padding: 25px;
      min-width: 202px;
      .head {
        font-weight: bold;
        font-size: 20px;
        margin-bottom: 10px;
      }
      .tail {
        display: inline-flex;
        font-style: italic;
        color: rgba(128, 128, 128, 0.527);
        align-items: center;
        i {
          margin-left: 2px;
          font-size: 15px;
          color: rgba(128, 128, 128, 0.527);
        }
      }
      .select-month-year {
        max-width: 200px;
        margin: 10px 0;
      }
    }
    .dashboard-box {
      position: relative;
      width: max-content;
      padding: 10px 20px;
      z-index: 1;
      font-size: 15px;
      text-align: center;
      .h-number {
        font-size: 30px;
        padding: 10px 0 5px;
        span {
          font-size: 15px;
        }
      }
      i {
        font-size: 15px;
      }
      .icon-box {
        display: inline-flex;
        padding: 5px 0 15px 0;
        i {
          color: #ffffff;
          font-size: 30px;
          box-shadow: 0 4px 4px -2px gray;
          border-radius: 50%;
          padding: 10px;
        }
        i.cash {
          background: #5d87ff;
        }
        i.bill {
          background: #27c5da;
        }
        i.discount {
          background: #f9896b;
        }
        i.booking {
          background: #ffaf1d;
        }
        i.renter {
          background: #17dd95;
          // background: #ffa33a;
        }
        i.area {
          background: #4abeff;
        }
        .image-icon {
          box-shadow: 0 4px 4px -2px gray;
          border-radius: 50%;
          padding: 10px;
        }
        .image-icon.area {
          background: #4abeff;
          img {
            padding: 4px;
            width: 30px;
            object-fit: contain;
            object-position: center;
          }
        }
      }
      span.plus {
        font-size: 18px;
        color: rgb(45, 192, 0);
      }
    }
    .dashboard-box:before {
      content: "";
      position: absolute;
      left: 0;
      bottom: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      height: 70%;
      border-left: 1px solid rgba(167, 167, 167, 0.507);
    }
    .dashboard-input {
      display: flex;
      align-items: center;
      justify-items: center;
      margin-right: 15px;
    }
  }
}
.gh {
  display: flex;
  justify-content: center;
}
</style>